<template>
  <div class="noticeList">
    <breadcrumb :list="breadcrumbList"></breadcrumb>
    <el-card class="main">
      <el-form ref="searchEmp" :model="searchEmp" class="searchEmp">
        <el-row>
          <el-col :xs="24" :sm="12" :md="6" :lg="6">
            <el-form-item label-width="80px">
              <div slot="label">标题</div>
              <el-input v-model="searchEmp.title" size="large"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6">
            <el-form-item label-width="80px">
              <div slot="label">发布人</div>
              <el-input v-model="searchEmp.creator" size="large"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="10" :lg="8">
            <el-form-item label-width="100px">
              <div slot="label">发布日期</div>
              <el-date-picker
                type="datetimerange"
                :clearable="false"
                placeholder=""
                v-model="date"
                value-format="timestamp"
                style="width: 100%"
                :picker-options="option"
                class="date"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="12" :lg="11" style="float: right">
            <el-row style="text-align: end; width: 100%">
              <el-button type="info" @click="clean_btn">重置</el-button>
              <el-button type="primary" @click="search_btn">查询</el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <Total :total="total"></Total>

      <!-- 表格 -->

      <el-row :gutter="20" style="margin-top: 20px">
        <el-col
          :xl="6"
          :lg="8"
          :md="12"
          :sm="24"
          :xs="24"
          v-for="item of tableData"
          :key="item.id"
        >
          <el-card
            class="noticeCard"
            shadow="always"
            :body-style="{ padding: '20px' }"
            style="
              border-radius: 0;
              position: relative;
              margin-bottom: 15px;
              height: 200px;
              cursor: pointer;
            "
            @dblclick.native="getDetail(item.id)"
          >
            <div
              style="
                width: 60px;
                height: 25px;
                position: absolute;
                top: 0;
                right: 0;
              "
              class="teti"
              v-if="item.level === 1"
            >
              特提
            </div>
            <div
              style="
                width: 60px;
                height: 25px;
                position: absolute;
                top: 0;
                right: 0;
              "
              class="teji"
              v-else-if="item.level === 2"
            >
              特急
            </div>
            <div
              style="
                width: 60px;
                height: 25px;
                position: absolute;
                top: 0;
                right: 0;
              "
              class="jiaji"
              v-else-if="item.level === 3"
            >
              加急
            </div>
            <div
              style="
                width: 60px;
                height: 25px;
                position: absolute;
                top: 0;
                right: 0;
              "
              class="pingji"
              v-else
            >
              平急
            </div>
            <div
              style="
                width: 70%;
                color: #555;
                text-align: left;
                font-size: 18px;
                font-weight: bold;
                color: #6347d8;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 20px;
              "
            >
              {{ item.title }}
            </div>
            <div
              style="
                width: 70%;
                color: #555;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              <i class="el-icon-collection-tag"></i>
              <span style="margin: 5px">发布单位：{{ item.creator_unit }}</span>
            </div>
            <div
              style="
                width: 70%;
                color: #555;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              <i class="el-icon-user"></i>
              <span style="margin: 5px">发布人：{{ item.creator }}</span>
            </div>
            <div style="color: #555; height: 25px">
              <div v-if="item.is_sign === 1">
                <i class="el-icon-document-checked"></i>
                <span
                  :style="{
                    margin: '5px',
                    color: item.is_signed === 1 ? '#67C23A' : '#F86A68'
                  }"
                  >签收状态：{{
                    item.is_signed === 1 ? '已签收' : '待签收'
                  }}</span
                >
              </div>
            </div>
            <el-divider
              direction="horizontal"
              content-position="left"
            ></el-divider>
            <div style="color: #555; text-align: left; position: relative">
              <i class="el-icon-time" v-if="item.push_time"></i>
              <span style="margin: 5px">
                {{ item.push_time ? day(item.push_time) : '' }}
              </span>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 分页 -->
      <div class="page">
        <el-pagination
          v-if="tableData.length != 0"
          class="fy"
          layout="prev, pager, next"
          :total="total"
          :page-size="pageData.page_size"
          :current-page="pageData.page_no"
          @current-change="current_change"
          background
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Total from '@/components/total/index.vue'
import * as user from '@/api/user.js'
import day from 'dayjs'
export default {
  name: 'NoticeIndex',
  data() {
    return {
      breadcrumbList: [{ name: '通知公告', path: 'notice' }],
      // 通知公告列表
      tableData: [],
      searchEmp: {},
      searchParam: {},
      date: '',
      // 列表总数
      total: 0,
      pageData: {
        // 当前页码
        page_no: 1,
        // 每页条数
        page_size: 12
      },
      option: {
        disabledDate(time) {
          let todayYear = new Date().getFullYear()
          let todayMonth = new Date().getMonth()
          let todayDay = new Date().getDate()
          let todayTime = new Date(
            todayYear,
            todayMonth,
            todayDay,
            '23',
            '59',
            '59'
          ).getTime() // 毫秒
          return time.getTime() > todayTime
        }
      }
    }
  },
  async created() {
    this.info()
  },
  methods: {
    // 时间格式化
    day(data) {
      if (Number(data)) {
        return day.unix(data).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return ''
      }
    },
    // 获取通知公告列表
    async info() {
      const res = await user.getNoticeList({
        ...this.pageData,
        ...this.searchParam
      })
      this.total = res.total_result
      this.pageData.page_no = res.page_no
      this.pageData.page_size = res.page_size
      this.tableData = res.items
    },
    // 详情
    getDetail(id) {
      console.log(id)
      this.$router.push({
        path: '/notice/notice_details',
        query: { id: id }
      })
    },
    // 重置
    clean_btn() {
      this.searchEmp = {}
      this.searchParam = {}
      this.date = ''
      this.info()
    },
    // 查询按钮操作
    search_btn() {
      this.pageData.page_no = 1
      this.searchParam = {
        start_time: this.date ? this.date[0] / 1000 : undefined,
        end_time: this.date ? this.date[1] / 1000 : undefined,
        title: this.searchEmp.title,
        creator: this.searchEmp.creator
      }
      this.info()
    },
    // 翻页
    current_change(val) {
      this.pageData.page_no = val
      this.info()
    }
  },
  beforeRouteLeave(to, from, next) {
    //离开页面如果去的详情  则缓存当前页面
    if (to.path === '/notice/notice_details') {
      this.$store.commit('setKeep', 'NoticeVue')
      next()
    } else {
      this.$store.commit('setKeep', '')
      next()
    }
    next()
  },
  components: { Total }
}
</script>

<style lang="less" scoped>
.noticeList {
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .teti {
    background: url('../../../assets/img/teji.png');
    color: #fff;
    text-align: center;
  }

  .pingji {
    background: url('../../../assets/img/pingji.png');
    color: #62dcd5;
    text-align: center;
  }

  .jiaji {
    background: url('../../../assets/img/jiajizise.png');
    color: #c08ffb;
    text-align: center;
  }

  .teji {
    background: url('../../../assets/img/jiaji.png');
    color: #fac86e;
    text-align: center;
  }
  /deep/ .el-table__row {
    .el-button {
      width: 60px;
      height: 32px;
      border-radius: 16px;
    }
  }
  /deep/.el-checkbox-group {
    // 隐藏 1
    .el-checkbox__label {
      display: none;
    }
  }
}
</style>
